// @flow
import React, {Component} from 'react';
import { connect } from 'react-redux';
import BrandsForm from '../../components/Brands/brandsForm';
import {
  clearBrandForm,
  clearTempUploadedProductBrand,
  createBrand,
  storeTemporaryBrandImage
} from '../../actions/brands';
import handleImageInput from '../../helpers/image/handleImageInput';

class BrandsFormHOC extends Component {
  state = {
    name: '',
    warning: undefined
  };

  componentDidMount() {
    this.props.clearBrandForm();
  }

  setField = (name, value) => {
    this.setState({
      [name]: value,
    })
  };

  handleSubmit = (evt) => {
    evt.preventDefault();
    if (!this.state.name.length) {
      this.setState({ warning: 'Please give a name to the brand!' });
      return false;
    }

    this.props.createBrand({
      name: this.state.name,
      logo: this.props.tempImage,
    })
  };

  clearWarning = () => {
    this.setState({warning: undefined});
  };

  render() {
    const {
      navigation, storeTemporaryBrandImage, tempImage, clearTempUploadedProductBrand
    } = this.props;
    return (
      <BrandsForm
        name={this.state.name}
        logo={this.state.logo}
        formWarningOpen={this.state.warning}
        clearWarning={this.clearWarning}
        setField={this.setField}
        handleSubmit={this.handleSubmit}
        handleImageInput={handleImageInput}
        storeTemporaryBrandImage={storeTemporaryBrandImage}
        tempImage={tempImage}
        clearTempUploadedProductBrand={clearTempUploadedProductBrand}
      />
    );
  }
}


const mapStateToProps = state => ({
  tempImage: state.brands.get('tempImage'),
});

const mapDispatchToProps = dispatch => {
  return {
    createBrand: (payload) => {
      dispatch(createBrand(payload))
    },
    storeTemporaryBrandImage: (payload) => {
      dispatch(storeTemporaryBrandImage(payload))
    },
    clearBrandForm: (payload) => {
      dispatch(clearBrandForm(payload))
    },
    clearTempUploadedProductBrand: (payload) => {
      dispatch(clearTempUploadedProductBrand(payload))
    },

  }
};

export default connect(mapStateToProps, mapDispatchToProps)(BrandsFormHOC);



// WEBPACK FOOTER //
// ./src/containers/Brands/brandsFormHOC.js